import { parseSEODate } from '@beef/shop-common';

type FeedbackPost = {
  publishDate: string;
  rating: number;
  text: string;
  title: string;
  userName: string;
};

type DevicePreview = {
  name: string;
  images: Array<{ imageUrl: string }>;
  price: number;
  absoluteBaseUrl: string;
  count: string;
  average: string;
  brandName: string;
  reviews: FeedbackPost[];
  description: string;
  sku: string;
  isOutOfStock: boolean;
  isPreorder: boolean;
};

export const generateDevicePreviewMarkup = (item: DevicePreview) => {
  const availability =
    (item.isPreorder && 'PreOrder') || (item.isOutOfStock && 'OutOfStock') || 'InStock';

  return {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: item.name,
    image: item.images.map((img) => `https:${img.imageUrl}`),
    description: item.description,
    sku: item.sku,
    mpn: item.sku,
    brand: {
      '@type': 'Brand',
      name: item.brandName,
    },
    offers: {
      '@type': 'Offer',
      price: item.price,
      priceCurrency: 'RUB',
      availability: `https://schema.org/${availability}`,
      url: item.absoluteBaseUrl,
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: item.average,
      reviewCount: item.count,
    },
    review: item.reviews.map((review) => ({
      '@type': 'Review',
      name: review.title,
      author: {
        '@type': 'Person',
        name: review.userName,
      },
      datePublished: parseSEODate(review.publishDate),
      reviewRating: {
        '@type': 'Rating',
        ratingValue: review.rating,
        bestRating: '5',
        worstRating: '1',
      },
      reviewBody: review.text,
    })),
  };
};
